import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageTemplate from '../../ui/page_template';
import {zajavlsConsentOrRefusalPageInit} from '@componentDP/js_react/redux/actions/zajavls_consent_or_refusal';
import LoadingZajavls from '../../skeletons/loading_zajavls';
import ConsentOrRefusalContainer from './consent_or_refusal_container';
import {cloneDeep} from 'lodash';
import ErrorText from '../../simple/ErrorText';
import Grid from '@material-ui/core/Grid';
import {withTranslation} from "react-i18next";

class ZajavlsConsentOrRefusal extends React.Component {
    constructor(props) {
        super(props);
        this.props.zajavlsConsentOrRefusalPageInit();
    }

    render() {
        const {zajavlsConsentOrRefusalPageLoaded, profileBasic, t} = this.props;
        const pageContent = Number(profileBasic.diploma_id) > 0
            ? (!zajavlsConsentOrRefusalPageLoaded
                ? <LoadingZajavls/>
                : <ConsentOrRefusalContainer/>)
            : <Grid container spacing={2}>
                <Grid item lg={8}>
                    <ErrorText
                        message={t('general_info_must_fill')} />
                </Grid>
            </Grid>
        return (
            <PageTemplate title={t('consent_or_refusal')}>
                {pageContent}
            </PageTemplate>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        zajavlsConsentOrRefusalPageLoaded: cloneDeep(state.zajavlsConsentOrRefusalPageLoaded),
        profileBasic: cloneDeep(state.profileBasic),
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    zajavlsConsentOrRefusalPageInit,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ZajavlsConsentOrRefusal));
